<template>
  <div>
    <div class="row">
      <p>به موجب هزینه پرداختی از طرف</p>
      &nbsp; &nbsp;
      {{ this.$session.get('UserInfo').namFam }}
      &nbsp; &nbsp; به مبلغ
      <div class="col-md-2 col-12">
        <input dir="ltr" type="text" class="form-control required text-left" v-model="item.amount" @keyup="item.Amount = $PutCommatoInput_New($event)" @keypress="$ValidNumber($event, 15)" />
      </div>
      ریال &nbsp;بابت
      <div class="col-md-3 col-12">
        <input type="text" class="form-control required" v-model="item.costSubject" />
      </div>
      پرداخت گردد.
    </div>
    <div class="row mt-4">
      <div class="col-md-8 col-12">
        <small id="LblFor">توضیحات</small>
        <textarea class="form-control required" style="resize: none; height: 80px" v-model="item.for"></textarea>
        <button v-if="EditMode == false" class="btn btn-success w-50 mt-3" @click="submit">ثـبـت</button>
        <button v-if="EditMode == true" class="btn btn-warning w-50 mt-3" @click="Edit">ویرایش</button>
      </div>
      <div class="col-md-4 col-12">
        <uploader @upload="GetFile"></uploader>
      </div>
    </div>
    <div class="col-12 mt-2"></div>

    <div class="d-flex justify-content-center"></div>
  </div>
</template>
<script>
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import Uploader from '@/components/Uploader/Uploader.vue'
export default {
  components: { SearchableCombo, Uploader },
  props: ['EditMode', 'EditRow','DataFormProps'],
  data() {
    return {
      item: {},
      File: null,
    }
  },

  mounted() {
    this.item = {}
    if (this.EditMode) {
      if (this.DataFormProps) {
        this.item.id=this.EditRow.id
        this.item.amount=this.$Comma3ragham(this.EditRow.amount)
        this.item.costSubject=this.EditRow.costSubject
        this.item.for=this.EditRow.for
        this.item.TblUserId=this.$session.get('UserInfo').tblUserId
        this.item.dateTimeInsert= this.EditRow.dateTimeInsert
        this.item.tblUserGrpIdInsert= this.EditRow.tblUserGrpIdInsert
        
      }
      else{
        this.item = this.EditRow
      }
    }
  },

  methods: {
    submit() {
      if (!this.$ValidForm(this.$route.name)) {
        return
      }
      let attachment = this.File
      if (attachment != undefined) {
        if (Math.round(attachment.size / 1000 > 10100)) {
          this.$mySweetDefaultTost('', 'حجم فایل پیوست باید کمتر از 10 مگ باشد', 'info', 2000)
          return
        }
      }

      let formData = new FormData()
      formData.append('For', this.item.for)
      formData.append('Amount', this.item.amount.replaceAll(',', ''))
      formData.append('costSubject', this.item.costSubject)
      formData.append('File', attachment)

      this.$PostData_new('post', 'CostPermission', formData, true)
        .then((res) => {
          if (res.isSuccess) {
            this.$mySweetDefaultTost('عملیات موفق', res.message, 'success', 2000)
            this.$emit('Result', res.isSuccess)
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', res.message, 'error', 2000)
          }
        })
        .catch((err) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطای سمت سرور', 'error', 2000)
          console.error(err)
        })
    },
    GetFile(data) {
      this.File = data
    },
    Edit() {
      if (!this.$ValidForm(this.$route.name)) {
        return
      }
      let attachment = this.File
      if (attachment != undefined) {
        if (Math.round(attachment.size / 1000 > 10100)) {
          this.$mySweetDefaultTost('', 'حجم فایل پیوست باید کمتر از 10 مگ باشد', 'info', 2000)
          return
        }
      }
      let formData = new FormData()
      formData.append('Id', this.item.id)
      formData.append('For', this.item.for)
      formData.append('CostSubject', this.item.costSubject)
      formData.append('Amount', this.item.amount.replaceAll(',', ''))
      formData.append('File', attachment)
      this.$PostData_new('put', 'CostPermission', formData, true)
        .then((res) => {
          if (res.isSuccess) {
            this.$mySweetDefaultTost('عملیات موفق', res.message, 'success', 2000)
            this.$emit('Result', res.isSuccess)
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', res.message, 'error', 2000)
          }
        })
        .catch((err) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطا سمت سرور', 'error', 2000)
          console.error(err)
        })
    },
  },
}
</script>
